<!--  -->
<template>
  <div class="container">
    <div class="hint">请选择你的工种类型</div>
    <van-radio-group v-model="radio">
      <van-cell-group>
        <van-cell
          v-for="(item,index) in workTypeList"
          :key="index"
          :title="item.name"
          clickable
          @click="selectType(item,index)"
        >
          <van-radio slot="right-icon" :name="index+1" />
        </van-cell>
        <!-- <van-cell title="单选框 2" clickable @click="radio = '2'">
          <van-radio slot="right-icon" name="2" />
        </van-cell>-->
      </van-cell-group>
    </van-radio-group>
    <button class="enter" @click="ok">确定</button>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Dialog,Toast } from "vant";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      radio: "1",
      type: "",
      id:null,
      course_id: null,
      workTypeList: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getworkTypeList() {
      this.$store.commit("showLoading");
      this.$http
        .getYearType({
          course_id: this.course_id
        })
        .then(res => {
          this.$store.commit("hideLoading");
          if (res.status == 1) {
            this.workTypeList = res.data;
          }
        });
    },
    selectType(data, index) {
      this.radio = index + 1;
      this.type = data.type;
    },
    ok() {
      if(this.type == ""){
        Toast('请选择类型');
      }else{
        this.$http.checkIfAge({
          course_id:this.course_id,
          type:this.type
      }).then(res=>{
          Dialog.alert({
          title: "提示",
          message: res.msg
        }).then(() => {
          if(res.status == 1){
            if(this.applyForm == 1){
              this.$router.push({path:"/applyForm",query:{id:this.id,course_id:this.course_id,work_type:this.type}})
            }else{
              this.$router.push({path:"/uploadingApplyData",query:{id:this.id,course_id:this.course_id,work_type:this.type}})
            }
          }else{
              Dialog.close()
          }
        });
      })
      }
      
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let course_id = this.$route.query.course_id;
    let id = this.$route.query.id;
    let applyForm = this.$route.query.apllyForm
    this.applyForm = applyForm
    this.course_id = course_id;
    this.id = id;
    this.getworkTypeList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  .hint {
    font-size: 13px;
    color: #666666;
    margin-left: 20px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .enter {
    width: 80%;
    height: 44px;
    background-color: #0e88f7;
    border: none;
    color: #ffffff;
    border-radius: 22px;
    font-size: 17px;
    display: block;
    text-align: center;
    line-height: 44px;
    margin: 40px auto;
  }
}
</style>